import NextImage from 'next/legacy/image'
import type { FunctionComponent } from 'react'
import { InternalLink } from '../../const/Links'
import { Translation, useTranslate } from '../../contexts/TranslationContext'
import { Button } from '../shared/Button'
import style from './RegisterSearchBanner.module.sass'

export const RegisterSearchBanner: FunctionComponent = () => {
	const translate = useTranslate()

	return (
		<div className={style.wrapper}>
			<div className={style.header}>
				<div className={style.title}>
					<Translation tr="registerSearchBanner.title" />
				</div>
			</div>
			<div className={style.content}>
				<div className={style.imageWrapper}>
					<NextImage
						src="/images/Puppy.png"
						alt={translate('registerSearchBanner.alt.image')}
						title={translate('registerSearchBanner.alt.image')}
						width={114}
						height={110}
					/>
				</div>
				<div className={style.buttonWrapper}>
					<Button label={translate('registerSearchBanner.button.register')} url={InternalLink.Register} />
				</div>
			</div>
		</div>
	)
}
